import EventEmitter from "eventemitter3";
export class GamepadEmitter extends EventEmitter {}
